import type { ISaleRepository, SaleStatsParams } from '@/features/sale/domain/repositories/ISaleRepository.js';
import type { SaleStats } from '@/features/sale/domain/entities/SaleEntity.js';

export function createGetSaleStatsUseCase(deps: { saleRepository: ISaleRepository }) {
  return async function getSaleStatsUseCase(params: SaleStatsParams): Promise<SaleStats> {
    return deps.saleRepository.getSaleStats(params);
  };
}

export type GetSaleStatsUseCase = ReturnType<typeof createGetSaleStatsUseCase>;
